"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-unused-vars */

exports.default = {
    rules: {
        60199: function _(region) {
            return region.hasParent(60199) && region.osmId != 72639 && region.osmId != 1574364 && region.osmId != 421866;
        }, //UA

        60189: function _(region) {
            return region.hasParent(60189) || region.osmId == 60189 || region.osmId == 72639;
        }, //RU w/o SEV
        28699: function _(region) {
            return region.hasParent(28699);
        }, //UA
        270056: function _(region) {
            return region.hasParent(270056) || region.osmId == 449220;
        }, //move TW to CN
        449220: function _(region) {
            return false;
        }, //drop TW
        192691: function _(region) {
            return region.hasParent(192691) || region.osmId == 195838;
        }, //move EH to MA
        195838: function _(region) {
            return false;
        }, //drop EH

        2514541: function _(region) {
            return false;
        }, //drop Cirpus
        3263728: function _(region) {
            return false;
        }, //drop Cirpus
        3263726: function _(region) {
            return false;
        }, //drop Cirpus

        2088990: function _(region) {
            return false;
        } //drop Kosovo
    },
    fixtures: {
        72639: {
            name: "Crimea",
            names: {
                "geonames": "Krym",
                "ru": "Крым",
                "en": "Crimea",
                "ar": "القرم",
                "de": "Krim",
                "es": "Crimea",
                "fr": "Crimée",
                "it": "Crimea",
                "zh": "克里米亞共和國"
            },
            iso: "CR",
            fips: null,
            reference: {
                geonames: 703883,
                openstreetmap: 72639,
                openstreetmap_level: 4,
                wikipedia: "en:Republic_of_Crimea",
                wof: null
            }
        },
        1574364: {
            "name": "Sevastopol",
            "iso": "SV",
            "fips": null
        }
    }
};